<template>
  <b-form-group
    label="Görüşme Notu"
    label-for="title"
  >
    <validation-provider
      #default="{ errors }"
      name="Görüşme Notu"
      rules="required"
    >
      <b-form-textarea
        v-model="dataItem.content"
        placeholder="Görüşme Notu"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BFormTextarea,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'Country',
  components: {
    BFormGroup,
    BFormTextarea,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['interviews/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
